import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bufferData: {}, 
  selectedBuffer: null,
  setFeatureTable:[]
};

const bufferSlice = createSlice({
  name: "buffer",
  initialState,
  reducers: {
    setBufferData: (state, action) => {
      const { bufferId, features, properties } = action.payload;
      state.bufferData = { features, properties, bufferId };
    },
    setSelectedBuffer: (state, action) => {
      state.selectedBuffer = action.payload;
    },
    setFeatureTable: (state, action) => {
      state.setFeatureTable = action.payload;
    },
  },
});

export const { setBufferData, setSelectedBuffer,setFeatureTable } = bufferSlice.actions;
export default bufferSlice.reducer;
